import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-single-select',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.css']
})
export class SingleSelectComponent implements OnInit {

  @Input() id;
  @Input() width;
  @Input() values;
  @Input() selectedValue;
  @Input() showSearchBox;
  @Input() type;
  @Input() keyName;
  @Input() displayName;
  @Input() placeHolder;
  @Input() disabled;

  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

  searchedString = "";
  openDropDownList = false;

  constructor() {

  }

  ngOnInit() {

  }

  toggleDropDown(){
    if (this.disabled === false){
      this.openDropDownList = !this.openDropDownList;
    }
    else{
      this.openDropDownList = false;
    }
  }

  select(index){
    this.openDropDownList = false;
    this.searchedString = "";
    this.onSelect.emit(this.values[index]);
  }

  ngOnDestroy(){

  }

}
